export class GCSBucket {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "locationType",
            "baseName": "locationType",
            "type": "GcsLocationType",
            "format": ""
        },
        {
            "name": "constituentRegions",
            "baseName": "constituentRegions",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GCSBucket.attributeTypeMap;
    }
    constructor() {
    }
}
